import React, {useEffect, useState} from 'react'
import {Button, InputRed, InputX} from 'components'
import useApp from 'hooks/useApp'
import {useNavigate} from 'react-router-dom'
import {useSetRecoilState} from 'recoil'
import {userLogInfoState} from '../states'
import {useLocation} from "react-router-dom";

const Email = () => {

    const App = useApp()
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [emailRed, setEmailRed] = useState(false)
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const setUserInfo = useSetRecoilState(userLogInfoState)
    const location = useLocation();

    const isWelcome = !!(location.state?.welcome);

    const onNext = () => {
        setUserInfo(info => {
            return {
                ...info,
                email: email
            }
        })
        navigate("/password", {state: {welcome: isWelcome}})
    }

    useEffect(() => {
        if (email.length === 0) return
        const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,4}$/i
        if (email && !regExp.test(email)) {
            setEmailRed(true)
            setButtonDisabled(true)
        } else {
            setEmailRed(false)
            setButtonDisabled(false)
        }
    }, [email])

    useEffect(() => {
        App.setHeader({
            show: true,
            title: <></>,
            left: undefined,
            right: undefined
        })

        App.setShowNav(false)
        App.setMainClass("white")

        if (isWelcome) {
            App.alert("다시 만나서 반가워요!<br/>" +
                "새로운 모니이용을 위해<br/>" +
                "몇 가지만 더 입력해 주세요!")
        }

        setTimeout(() => {
            document.querySelector("[name='email']").focus()
        }, 500)
    }, [])

    return (
        <div className="page">
            <div className="flex_1 padding">
                <h3>이메일을 입력해주세요.</h3>
                <p className="guide-title mt_40">이메일</p>
                <InputX focus type="text" name="email" placeholder="이메일 입력" defaultValue={email} onChange={e => {
                    const value = e.target.value
                    setEmail(value)
                }} className="mt_10"/>
                <InputRed text="올바른 이메일 형식이 아니에요." show={emailRed}/>
            </div>
            <div className="flex-shrink_0 padding">
                <Button className="btn btn--big" disabled={buttonDisabled} onClick={onNext}>다음</Button>
            </div>
        </div>
    )
}

export default Email